const updates = [
  {
    date: '07-31',
    title: '《长安十二时辰》高清修复版全集上线',
    desc: '雷佳音、易烊千玺主演，4K 画质修复，带你重回盛世长安',
    badge: '新',
  },
  {
    date: '07-30',
    title: '《流浪地球3》蓝光版本正式发布',
    desc: '年度科幻巨制，4K HDR 画质呈现，多版本可选',
    badge: '热',
  },
  {
    date: '07-29',
    title: '2026 年暑期档专题页面上线',
    desc: '收录暑期热门影视 50+ 部，一站式追剧观影指南',
    badge: '',
  },
  {
    date: '07-28',
    title: '韩剧专区新增《黑暗荣耀》第二季',
    desc: '宋慧乔复仇之路终章，豆瓣评分 9.1 高分韩剧',
    badge: '',
  },
  {
    date: '07-27',
    title: '播放器全面升级至 4.0 版本',
    desc: '更流畅的播放体验，新增倍速播放和记忆续播功能',
    badge: '',
  },
  {
    date: '07-26',
    title: '动漫专区上线《鬼灭之刃 柱训练篇》',
    desc: '热血动作场面全收录，日语原声+中文字幕',
    badge: '',
  },
  {
    date: '07-25',
    title: '《繁花》沪语版及普通话版双版本上线',
    desc: '王家卫导演力作，感受上海话原汁原味的独特魅力',
    badge: '',
  },
  {
    date: '07-24',
    title: '纪录片专区全新改版上线',
    desc: 'BBC、国家地理等顶级纪录片入驻，覆盖自然人文科技',
    badge: '',
  },
  {
    date: '07-23',
    title: '《漫长的季节》再登热搜，限时免费看全集',
    desc: '豆瓣 9.4 分神剧，范伟秦昊封神演技，不容错过',
    badge: '',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            最新更新
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            平台动态与内容更新快讯，不错过任何精彩上线
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[39px] md:left-[47px] top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="flex flex-col gap-5 md:gap-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-4 md:gap-5 pl-0">
                <div className="relative z-10 flex-shrink-0 w-[78px] md:w-[94px] flex flex-col items-center">
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50 border-2 border-primary-500">
                    <span className="text-[10px] md:text-xs font-black text-primary-500 leading-none">
                      {item.date.split('-')[0]}
                    </span>
                  </div>
                </div>
                <div className="flex-1 min-w-0 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300/50 transition-all duration-200">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    {item.badge && (
                      <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${
                        item.badge === '新'
                          ? 'bg-primary-500 text-white'
                          : 'bg-accent-500 text-white'
                      }`}>
                        {item.badge}
                      </span>
                    )}
                  </div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}